import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { isAfter, parseISO } from 'date-fns';
import { task, timeout } from 'ember-concurrency';
import { APP } from 'garaje/utils/enums';
let PairingCodeInput = (_class = class PairingCodeInput extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "graphql", _descriptor, this);
    _initializerDefineProperty(this, "roombaMetrics", _descriptor2, this);
    _initializerDefineProperty(this, "inputValue", _descriptor3, this);
    _initializerDefineProperty(this, "showErrorOnPair", _descriptor4, this);
    _defineProperty(this, "pairDeviceTask", _buildTask(() => ({
      context: this,
      generator: function* (code) {
        this.showErrorOnPair = false;
        let devicePairingStatus;
        try {
          devicePairingStatus = yield this.graphql.approveDeviceUserCode(code, this.args.room.id);
        } catch (error) {
          // TODO: we should update the displayed error message based on the this error
          this.showErrorOnPair = true;
        }
        if (!devicePairingStatus) {
          return;
        }
        this.roombaMetrics.trackEvent('pairing_code_approved', {
          user_code: code,
          room_id: this.args.room.id,
          product: APP.ROOMS,
          company_id: this.args.room.companyId
        });
        yield this.pollForDevicePairingStatus.perform(devicePairingStatus);
      }
    }), {
      restartable: true
    }, "pairDeviceTask", null));
    _defineProperty(this, "pollForDevicePairingStatus", _buildTask(() => ({
      context: this,
      generator: function* (devicePairingStatus) {
        let pairingStatus;
        this.roombaMetrics.trackEvent('start_polling_for_device_pairing_status', {
          device_pairing_status_id: devicePairingStatus.id,
          device_id: devicePairingStatus.deviceId,
          room_id: this.args.room.id,
          product: APP.ROOMS,
          company_id: this.args.room.companyId
        });
        do {
          pairingStatus = yield this.fetchDevicePairingStatusTask.perform(devicePairingStatus.id);
          yield timeout(devicePairingStatus.interval);
        } while ((!pairingStatus || !pairingStatus.deviceId) && isAfter(parseISO(devicePairingStatus.expiresAt), new Date()));
        yield this.args.onDevicePaired();
        this.roombaMetrics.trackEvent('device_paired', {
          device_pairing_status_id: devicePairingStatus.id,
          device_id: devicePairingStatus.deviceId,
          room_id: this.args.room.id,
          product: APP.ROOMS,
          company_id: this.args.room.companyId
        });
        this.inputValue = '';
      }
    }), {
      restartable: true
    }, "pollForDevicePairingStatus", null));
    _defineProperty(this, "fetchDevicePairingStatusTask", _buildTask(() => ({
      context: this,
      generator: function* (id) {
        try {
          return yield this.graphql.getDevicePairingStatus(id);
        } catch (error) {
          return null;
        }
      }
    }), {
      restartable: true
    }, "fetchDevicePairingStatusTask", null));
  }
  focusInput(element) {
    if (!this.args.shouldAutofocusInput || !element) {
      return;
    }
    element && element.focus();
  }
  async onInputCode(event) {
    const value = event.target && 'value' in event.target ? event.target['value'] : null;
    if (!value?.trim()) {
      return;
    }
    this.inputValue = value?.slice(0, 6).toUpperCase();
    if (value.length < 6) {
      return;
    }
    await this.pairDeviceTask.perform(this.inputValue);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "roombaMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "inputValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showErrorOnPair", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "focusInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputCode"), _class.prototype)), _class);
export { PairingCodeInput as default };